import React, { useState } from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import TextField from "../../../Form/Input";
import { GeneralCommentsModalWrapper } from "../styles";
import { NoteText, NoteWarning } from "./styles";

export const COMMENT_MAX_LENGTH = 250;

export interface Props {
  open: boolean;
  closeModal: () => void;
  handleAddNewComment: (comment: string) => void;
}

const AddCommentModal = ({ open, closeModal, handleAddNewComment }: Props) => {
  const { t: translate } = useTranslation();

  const [comment, setComment] = useState<string>("");

  const commentLength = comment.length;
  const isNearLimit = commentLength >= Math.floor(COMMENT_MAX_LENGTH * 0.9);
  const isLimitReached = commentLength >= COMMENT_MAX_LENGTH;

  const handleCloseModal = () => {
    closeModal();
    setComment("");
  };

  const handleSubmit = () => {
    if (comment) {
      handleAddNewComment(comment);
    }

    handleCloseModal();
  };

  return (
    <GeneralCommentsModalWrapper
      open={open}
      title={translate("createNewComment")}
      handleClose={handleCloseModal}
      data-cy="addCommentModal"
      dataCyTitle="addCommentModalTitle"
      showActionButtons={true}
      actionButtonProps={{
        textCancel: translate("cancel"),
        dataCyCancel: translate("cancelButton"),
        onCancel: () => handleCloseModal(),
        dataCySave: "createCommentButton",
        textSave: translate("create"),
        saveDisabled: !comment.trim().length,
        onSave: handleSubmit,
      }}
    >
      <Grid container direction="row">
        <Grid item xs={12} paddingBottom={2}>
          <TextField
            name="newComment"
            data-cy="newComment"
            multiline
            minRows={3}
            maxRows={5}
            maxLength={COMMENT_MAX_LENGTH}
            placeholder={translate("typeYourCommentsHere")}
            label={translate("comment")}
            value={comment}
            required
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setComment(event?.target.value);
            }}
          />
        </Grid>

        <Grid container xs={12} justifyContent={"space-between"} alignItems={"center"}>
          <NoteText>
            {translate("commentCharactersCount", {
              count: commentLength,
              limit: COMMENT_MAX_LENGTH,
            })}
          </NoteText>
          {(isNearLimit || isLimitReached) && (
            <NoteWarning>
              {isLimitReached
                ? translate("commentLimitReached")
                : translate("commentLimitApproaching")}
            </NoteWarning>
          )}
        </Grid>
      </Grid>
    </GeneralCommentsModalWrapper>
  );
};

export default AddCommentModal;
